import React from 'react'
import { useS4LContext } from '@s4l/react-context'

import RequestMessage from '../RequestMessage'
import { IconPeople } from '@s4l/icons/IconPeople'
import { IconCallCenter } from '@s4l/icons/IconCallCenter'

import type { SpecialRequest } from '../index'

interface IRequestList {
  specialRequests: SpecialRequest[]
}

function RequestList({ specialRequests }: Readonly<IRequestList>) {
  const { i18n } = useS4LContext()
  const showDefaultMessage = specialRequests.length > 0

  return (
    <>
      {specialRequests.map((item, index) => (
        <div key={item.requestKey ?? item.requestValue} data-testid={`special-requests-${index}`}>
          <RequestMessage
            icon={IconPeople}
            title={
              item.requestKey ||
              (item.datetime
                ? i18n.formatTime(item.datetime, {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                  })
                : '')
            }
          >
            <span data-testid={`comment-${index}`}>{item.requestValue}</span>
          </RequestMessage>
        </div>
      ))}

      {showDefaultMessage && (
        <RequestMessage
          hasBackground
          icon={IconCallCenter}
          title={i18n.formatMessage({ id: 'room.special-requests-default-message' })}
        />
      )}
    </>
  )
}

RequestList.displayName = 'RequestList'

export default RequestList
